import * as constants from '../shared/constants';

export const ASSETS_PATH = 'assets';
export const VIDOE_DESKTOP_PATH = 'assets/video/desktop';
export const VIDOE_MOBILE_PATH = 'assets/video/mobile';
export const GAME_STATE_INITIAL_LOADING = 10;
export const GAME_STATE_START_SCENE = 20;
export const GAME_STATE_SELECTION_SCENE = 30;
export const GAME_STATE_PLAYING_SCENE = 30;
export const GAME_STATE_END = 30;

export const WEB_SOCKET_APP_PORT = constants.WEB_SOCKET_APP_PORT;

export const KEY_CODE_W = 119;
export const KEY_CODE_A = 97;
export const KEY_CODE_S = 115;
export const KEY_CODE_D = 100;
export const KEY_CODE_F = 102;
export const KEY_CODE_G = 103;
export const KEY_CODE_B = 98;
export const KEY_CODE_T = 116;
export const KEY_CODE_V = 118;
export const KEY_CODE_Y = 121;
export const KEY_CODE_ENTER = 13;
export const KEY_CODE_SPACE = 32;




export const ITEM_FEN     = constants.ITEM_FEN;
export const ITEM_BANAN   = constants.ITEM_BANAN;
export const ITEM_TUFLYA  = constants.ITEM_TUFLYA;
export const ITEM_VANTUZ  = constants.ITEM_VANTUZ;
export const ITEM_YAD     = constants.ITEM_YAD;

export const ITEM_LOSINI = 'los';
export const ITEM_SNAKE = 'snk';
export const ITEM_PISTOL = 'pis';

export const ITEM_WEIGHT_DELTA  = constants.ITEM_WEIGHT_DELTA;

export const SCENE_NAME_MENU              = 'menu';
export const SCENE_NAME_ITEM_SELECTION    = 'itemSelection';
export const SCENE_NAME_LOOP              = 'loop';
export const SCENE_NAME_ACTION_HAMLET_WIN = 'hamletWin';
export const SCENE_NAME_ACTION_KING_WIN   = 'kingWin';

export const TIMER_DURATION = 30 * 1000;
export const FINAL_WIN_TO_MENU_DURATION = 5000;
export const FINAL_LOSE_TO_MENU_DURATION_WHEN_WAS_WEIGHT = 3000;
export const FINAL_LOSE_TO_MENU_DURATION_WHEN_NO_WEIGHT = 6000;



/** WEBPACK FOOTER **
 ** ./src/client/constants.js
 **/